import { BasePageProps, BasePageState, basePageInitialState } from '../BasePage'

import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface VintageCarProps extends BasePageProps {}

type VintageCarState = {
    targa: string | undefined
    targaError: string | undefined
}

export type VintageCarPageState = VintageCarState & BasePageState

export const vintagecarInitialState : VintageCarPageState = {
    ...basePageInitialState,
    ...{
        targa: undefined,
        targaError: undefined,
    }
}

export const vintagecarUpdate = createAction<VintageCarPageState>('vintagecar/update')

export const vintagecarReducer = createReducer ( 
    vintagecarInitialState,
    (builder) => {
        builder.addCase(vintagecarUpdate, (state, action) => {
            return action.payload as VintageCarPageState
        })
    }
)

export type VintageCarRootState = ReturnType<typeof store.getState>
export type VintageCarDispatch = typeof store.dispatch